module.exports = __WEBPACK_EXTERNAL_MODULE_28__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/form-field/dist/mdc.formField","commonjs2":"@material/form-field/dist/mdc.formField","commonjs":"@material/form-field/dist/mdc.formField","amd":"@material/form-field/dist/mdc.formField","umd":"@material/form-field/dist/mdc.formField"}
// module id = 28
// module chunks = 0